
export default (displayedPools: any, page: number, resultsPerPage: number, numberOfPages: number, setPools: Function, setPage: Function) => (poolId: string) => {
  
  const willLastPageBeBlank: boolean = (displayedPools.length - 1) % resultsPerPage === 0;
  const isCurrentPageLast: boolean = page === numberOfPages;
  
  setPools((ps: any) => [...ps.filter((item: any) => (item._id !== poolId))]);
  
  if(willLastPageBeBlank && isCurrentPageLast) {
    setPage((ps: number) => ps - 1);
  }
}